"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyData = exports.signData = exports.signDataWithPassphrase = exports.signDataWithPrivateKey = exports.signAndPrintMessage = exports.printSignedMessage = exports.verifyMessageWithPublicKey = exports.signMessageWithPassphrase = exports.digestMessage = void 0;

var varuint_bitcoin_1 = require("varuint-bitcoin");

var constants_1 = require("./constants");

var hash_1 = require("./hash");

var keys_1 = require("./keys");

var nacl_1 = require("./nacl");

var createHeader = function createHeader(text) {
  return "-----".concat(text, "-----");
};

var signedMessageHeader = createHeader('BEGIN LISK SIGNED MESSAGE');
var messageHeader = createHeader('MESSAGE');
var publicKeyHeader = createHeader('PUBLIC KEY');
var signatureHeader = createHeader('SIGNATURE');
var signatureFooter = createHeader('END LISK SIGNED MESSAGE');
var SIGNED_MESSAGE_PREFIX_BYTES = Buffer.from(constants_1.SIGNED_MESSAGE_PREFIX, 'utf8');
var SIGNED_MESSAGE_PREFIX_LENGTH = varuint_bitcoin_1.encode(constants_1.SIGNED_MESSAGE_PREFIX.length);

var digestMessage = function digestMessage(message) {
  var msgBytes = Buffer.from(message, 'utf8');
  var msgLenBytes = varuint_bitcoin_1.encode(message.length);
  var dataBytes = Buffer.concat([SIGNED_MESSAGE_PREFIX_LENGTH, SIGNED_MESSAGE_PREFIX_BYTES, msgLenBytes, msgBytes]);
  return hash_1.hash(hash_1.hash(dataBytes));
};

exports.digestMessage = digestMessage;

var signMessageWithPassphrase = function signMessageWithPassphrase(message, passphrase) {
  var msgBytes = exports.digestMessage(message);

  var _keys_1$getPrivateAnd = keys_1.getPrivateAndPublicKeyFromPassphrase(passphrase),
      privateKey = _keys_1$getPrivateAnd.privateKey,
      publicKey = _keys_1$getPrivateAnd.publicKey;

  var signature = nacl_1.signDetached(msgBytes, privateKey);
  return {
    message: message,
    publicKey: publicKey,
    signature: signature
  };
};

exports.signMessageWithPassphrase = signMessageWithPassphrase;

var verifyMessageWithPublicKey = function verifyMessageWithPublicKey(_ref) {
  var message = _ref.message,
      publicKey = _ref.publicKey,
      signature = _ref.signature;
  var msgBytes = exports.digestMessage(message);

  if (publicKey.length !== nacl_1.NACL_SIGN_PUBLICKEY_LENGTH) {
    throw new Error("Invalid publicKey, expected ".concat(nacl_1.NACL_SIGN_PUBLICKEY_LENGTH.toString(), "-byte publicKey"));
  }

  if (signature.length !== nacl_1.NACL_SIGN_SIGNATURE_LENGTH) {
    throw new Error("Invalid signature length, expected ".concat(nacl_1.NACL_SIGN_SIGNATURE_LENGTH.toString(), "-byte signature"));
  }

  return nacl_1.verifyDetached(msgBytes, signature, publicKey);
};

exports.verifyMessageWithPublicKey = verifyMessageWithPublicKey;

var printSignedMessage = function printSignedMessage(_ref2) {
  var message = _ref2.message,
      signature = _ref2.signature,
      publicKey = _ref2.publicKey;
  return [signedMessageHeader, messageHeader, message, publicKeyHeader, publicKey.toString('hex'), signatureHeader, signature.toString('hex'), signatureFooter].filter(Boolean).join('\n');
};

exports.printSignedMessage = printSignedMessage;

var signAndPrintMessage = function signAndPrintMessage(message, passphrase) {
  var signedMessage = exports.signMessageWithPassphrase(message, passphrase);
  return exports.printSignedMessage(signedMessage);
};

exports.signAndPrintMessage = signAndPrintMessage;

var signDataWithPrivateKey = function signDataWithPrivateKey(data, privateKey) {
  return nacl_1.signDetached(data, privateKey);
};

exports.signDataWithPrivateKey = signDataWithPrivateKey;

var signDataWithPassphrase = function signDataWithPassphrase(data, passphrase) {
  var _keys_1$getPrivateAnd2 = keys_1.getPrivateAndPublicKeyFromPassphrase(passphrase),
      privateKey = _keys_1$getPrivateAnd2.privateKey;

  return exports.signDataWithPrivateKey(data, privateKey);
};

exports.signDataWithPassphrase = signDataWithPassphrase;
exports.signData = exports.signDataWithPassphrase;

var verifyData = function verifyData(data, signature, publicKey) {
  return nacl_1.verifyDetached(data, signature, publicKey);
};

exports.verifyData = verifyData;